'use client'

import { ArrowLeft } from 'lucide-react'
import * as React from 'react'

import { cn } from '../cn'
import { Button } from './button'

export interface AppSearchDialogHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Invoked when the mobile back-arrow is tapped. */
  onClose: () => void
  /** Override the back-arrow button's aria-label. */
  backLabel?: string
}

const AppSearchDialogHeader = React.forwardRef<HTMLDivElement, AppSearchDialogHeaderProps>(
  ({ onClose, backLabel = 'Close', className, children, ...props }, ref) => (
    <div
      ref={ref}
      className={cn('flex items-center gap-2 p-3 md:px-4 md:pt-4 md:pb-3 border-b shrink-0', className)}
      {...props}>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="h-10 w-10 shrink-0 md:hidden"
        onClick={onClose}
        aria-label={backLabel}>
        <ArrowLeft className="h-5 w-5" />
      </Button>
      {children}
    </div>
  ),
)
AppSearchDialogHeader.displayName = 'AppSearchDialogHeader'

export { AppSearchDialogHeader }
